import { ControlGroup, FormGroup, HTMLSelect, IOptionProps } from "@blueprintjs/core";
import { Businesses, Users } from "@just-in-types";
import { css } from "emotion";
import * as React from "react";
import { connect } from "react-redux";
import { IState } from "../store";

const Hidden = css("display: none;");

const withControlGroup: React.SFC<{ isVertical?: boolean }> = ({ isVertical, ...props }) => (
  <ControlGroup vertical={isVertical} {...props} />
);

interface Option extends IOptionProps {
  value: string;
}
export interface Selected {
  businessId: null | string;
  businessPath: null | string;
  siteId: null | string;
  sitePath: null | string;
}

interface SitePickerOwnProps {
  childrenRight?: JSX.Element | JSX.Element[];
  disabled?: boolean;
  filter?: boolean;
  hasAll?: boolean;
  hasLabels?: boolean;
  hideBusiness?: boolean;
  hideSites?: boolean;
  isVertical?: boolean;
  onSelect: (selected: Selected) => void;
}

interface SitePickerStateProps {
  businesses: Businesses.Business[];
  permissions: Users.Permissions;
}

type SitePickerProps = SitePickerOwnProps & SitePickerStateProps;

interface SitePickerState {
  businessId: null | string;
  businessOptions: Option[];
  siteId: null | string;
  siteOptions: Option[];
}

const formatString = (path)=>{
  const strArr = path.split('-')
  strArr.forEach((ele, index) => {
    strArr[index] = ele.charAt(0).toUpperCase() + ele.slice(1);
  });
  return strArr.join(' ');
}

const buildSiteOptions = (sites: Businesses.Site[], siteOptions: Option[], siteFilter: null | string[]) => {
  sites.forEach(({ path, siteId, isArchive }) => {
    if (isArchive === "1") {
      return;
    }
    const newPath = formatString(path);

    if (siteFilter) {
      if (siteFilter.length === 0 || siteFilter.indexOf(siteId) !== -1) {
        siteOptions.push({ label: newPath, value: siteId });
      }
    } else {
      siteOptions.push({ label: newPath, value: siteId});
    }
  });

  return siteOptions;
};

const buildOptions = (
  businesses: Businesses.Business[],
  businessSitesId: null | string,
  permissions: null | Users.Permissions,
  hasAll?: boolean
) => {
  const businessFilter = permissions ? permissions.businesses : null;
  const businessOptions: Option[] = [];
  const siteFilter = permissions ? permissions.sites : null;
  const siteOptions: Option[] = [];

  let nextBusinessId = businessSitesId;
  let nextBusinessIdSet = false;

  businesses.forEach(({ businessId, path, sites, isArchive }) => {
    // console.log("isArchive", isArchive);

    const newPath = formatString(path);
    if (isArchive === 1) {
      return;
    }
    if (businessFilter) {
      if (businessFilter.length === 0 || businessFilter.indexOf(businessId) !== -1) {
        if (!nextBusinessIdSet) {
          nextBusinessIdSet = true;
          nextBusinessId = businessId;
          buildSiteOptions(sites, siteOptions, siteFilter);
        }

        businessOptions.push({ label: newPath, value: businessId });
      }
    } else {
      if (!nextBusinessIdSet) {
        nextBusinessIdSet = true;
        nextBusinessId = businessId;
        buildSiteOptions(sites, siteOptions, siteFilter);
      }
      businessOptions.push({ label: newPath, value: businessId });
    }
  });

  return {
    businessOptions,
    nextBusinessId,
    nextSiteId: hasAll ? "all" : siteOptions[0] ? siteOptions[0].value : null,
    siteOptions,
  };
};

class SitePicker extends React.Component<SitePickerProps, SitePickerState> {
  public static getDerivedStateFromProps(
    { businesses, filter, hasAll, permissions }: SitePickerProps,
    { businessId, siteId }: SitePickerState
  ) {
    const isAdmin = permissions.role === "admin";
    const requiredPermissions = isAdmin ? null : filter === true ? permissions : null;
    const { businessOptions, nextBusinessId, nextSiteId, siteOptions } = buildOptions(
      businesses,
      businessId,
      requiredPermissions,
      hasAll
    );

    return {
      businessId: businessId || nextBusinessId,
      businessOptions,
      siteId: siteId || nextSiteId,
      siteOptions,
    };
  }

  public state: SitePickerState = {
    businessId: null,
    businessOptions: [],
    siteId: null,
    siteOptions: [],
  };

  private businessSelect: null | HTMLSelectElement = null;
  private siteSelect: null | HTMLSelectElement = null;

  public componentDidMount() {
    this.sendSelection();
  }

  public componentDidUpdate(
    prevProps: SitePickerProps,
    { businessId: prevBusinessId, siteId: prevSiteId }: SitePickerState
  ) {
    const { businessId: nextBusinessId, siteId: nextSiteId } = this.state;

    if ((prevBusinessId !== nextBusinessId || prevSiteId !== nextSiteId) && this.businessSelect && this.siteSelect) {
      this.sendSelection();
    }
  }

  public sendSelection = () => {
    if (this.businessSelect && this.siteSelect && this.businessSelect.selectedOptions.length > 0) {
      const { businesses, onSelect } = this.props;

      
      
      const businessOption = this.businessSelect.selectedOptions[0];
      const businessId = businessOption.value;
      // const businessPathOld = businessOption.label;

      const siteOption = this.siteSelect.selectedOptions[0];
      const siteId = siteOption.value;
      // const sitePath = siteOption.label;
      
      const activeBusiness = businesses.find((b) => b.businessId === businessId);

      const sites = activeBusiness?activeBusiness.sites:'';

      const activeSites = sites ? sites.find((b) => b.siteId === siteId) : '';
      
      const businessPath = activeBusiness?activeBusiness.path:''; 
      const sitePath = activeSites?activeSites.path:'all';
       
      onSelect({ businessId, businessPath, siteId, sitePath });
    }
  };

  public render() {
    const {
      businesses,
      childrenRight,
      filter,
      hasAll,
      hasLabels,
      hideBusiness,
      hideSites,
      isVertical,
      permissions,
    } = this.props;
    const { businessId, businessOptions, siteId } = this.state;
    const activeBusiness = businesses.find((b) => b.businessId === businessId);
    const siteOptions = activeBusiness
      ? buildSiteOptions(activeBusiness.sites, [], filter ? permissions.sites : [])
      : [];
    const businessHidden = hideBusiness || businessOptions.length === 1;
    const businessInput = (
      <HTMLSelect
        className={businessHidden ? Hidden : undefined}
        elementRef={(ref) => (this.businessSelect = ref)}
        onChange={this.handleBusiness}
        options={businessOptions}
        value={businessId || "all"}
      />
    );
    const tearApartOgdenSite = [{ label: "Ogden", value: "ogden" }];
    const tearApartSlcSite = [{ label: "Salt Lake City", value: "slc" }];
    const tearApartAllSite = [{ label: "all", value: "all" }, { label: "Ogden", value: "ogden" }, { label: "Salt Lake City", value: "slc" }];
    
    let tearPartSite = tearApartAllSite;

    if(this.props.permissions && this.props.permissions.tearApartSiteId && this.props.permissions.tearApartSiteId === 'slc'){
      tearPartSite = tearApartSlcSite;
    }else if(this.props.permissions && this.props.permissions.tearApartSiteId && this.props.permissions.tearApartSiteId === 'ogden'){
      tearPartSite = tearApartOgdenSite;
    }else{
      tearPartSite = tearApartAllSite;
    }

    // console.log(this.props.permissions.tearApartSiteId);
    // console.log(tearPartSite);

    const siteInput = businessId === "gBHr1GdJSlpASgUvkoLW"?
    (
      <HTMLSelect
        className={hideSites ? Hidden : undefined}
        elementRef={(ref) => (this.siteSelect = ref)}
        onChange={this.handleSite}
        options={tearPartSite}
        // options={[{ label: "all", value: "all" }, { label: "Ogden", value: "ogden" }, { label: "Salt Lake City", value: "slc" }]}
        value={siteId || "all"}
      />
    ):
    (
      <HTMLSelect
        className={hideSites ? Hidden : undefined}
        elementRef={(ref) => (this.siteSelect = ref)}
        onChange={this.handleSite}
        options={hasAll ? [{ label: "all", value: "all" }, ...siteOptions] : siteOptions}
        value={siteId || "all"}
      />
    );
    const inputs = hasLabels ? (
      <>
        <FormGroup className={businessHidden ? Hidden : undefined} label="business">
          {businessInput}
        </FormGroup>
        <FormGroup className={hideSites ? Hidden : undefined} label="location">
          {siteInput}
        </FormGroup>
        {childrenRight}
      </>
    ) : (
      <ControlGroup>
        {businessInput}
        {siteInput}
        {childrenRight}
      </ControlGroup>
    );

    return businessHidden ? inputs : withControlGroup({ children: inputs, isVertical });
  }

  private handleBusiness = ({ currentTarget: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
    const businessId = value;

    this.setState({ businessId });
  };

  private handleSite = ({ currentTarget: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
    const siteId = value;

    this.setState({ siteId });
  };
}

const mapStateToProps = ({ businesses: { businesses }, users: { currentUser, permissions } }: IState) => ({
  businesses,
  currentUser,
  permissions,
});

export type ConnectedSitePicker = React.Component<
  Pick<SitePickerProps, "disabled" | "filter" | "hasLabels" | "isVertical" | "onSelect">,
  any,
  any
> | null;

export default connect<SitePickerStateProps, {}, SitePickerOwnProps>(
  mapStateToProps,
  null,
  null,
  { withRef: true }
)(SitePicker);



// WEBPACK FOOTER //
// ./src/components/SitePicker.tsx